export const BUY_REASONS = [
  { id: 1, name: 'Cobertura / Acompanhamento' },
  { id: 2, name: 'Tratamento' },
  { id: 3, name: 'Consultas / Exames' },
  { id: 4, name: 'Empresarial' }
]

export const getBuyReason = (reasonId: string) =>
  BUY_REASONS.find(({ id }) => id === Number(reasonId))
